import React from 'react'

import styled from '@emotion/styled'
import { mq, black02, green01, text } from '../../_style'

const Container = styled.h3`
  ${text('26px', 38 / 26)}
  letter-spacing: 0.1em;
  font-feature-settings: "palt";
  ${mq.sp} {
    ${text('21px', 72 / 52)}
  }
  ${props => props.isGreen && `color: ${green01};`}
`
export default class SubHeading extends React.Component {
  render() {
    return(
      <Container isGreen={this.props.isGreen}>
        {this.props.children}
      </Container>
    )
  }
}
